export const activePromos = ['fixed', 'included', 'included_fixedPrice', 'special', 'limited_promo', 'additional_cost'];

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
